import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// Set background image from public folder to avoid webpack resolving errors
if (document && document.body) {
  const bgUrl = `${process.env.PUBLIC_URL || ''}/images/bg.png`;
  document.body.style.backgroundImage = `url('${bgUrl}')`;
  document.body.style.backgroundRepeat = 'repeat';
}

registerServiceWorker();
